/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {AoaBoard} from './aoa-board.model';
import {Service} from '../../../common/service.class';
import {UserModelListService} from '../../../common/user-model-list.service';

@Injectable()
export class AoaBoardService extends UserModelListService<AoaBoard> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'aoaBoard', AoaBoard);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/aoa/aoa-board.service.ts